import { FormControl, FormHelperText, Grid, TextField } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useAsyncAction } from 'app/services';
import { reportTypeLoad } from 'app/store/report';
import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import { Controller, useForm } from 'react-hook-form';

const UserReportForm = forwardRef((props, ref) => {
  const { asyncAction: fetchTypeData } = useAsyncAction(reportTypeLoad);
  const { onSubmit } = props;
  const { control, watch, register, formState, setValue, handleSubmit } = useForm({
    defaultValues: {
      from: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      to: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
    },
  });

  const fromWatch = watch('from');

  const handleChangeFromDatetime = (newValue) => {
    setValue('from', moment(newValue).format('YYYY-MM-DD HH:mm:ss'));
  };

  const handleChangeToDatetime = (newValue) => {
    setValue('to', moment(newValue).format('YYYY-MM-DD HH:mm:ss'));
  };

  useImperativeHandle(ref, () => ({
    handleFormSubmit: () => {
      handleSubmit((data) =>
        onSubmit({
          from: data.from,
          to: data.to,
          type_id: 4,
        })
      )();
    },
  }));

  useEffect(() => {
    fetchTypeData();
  }, []);

  return (
    <form>
      <Grid container spacing={2}>
        <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale={moment.locale('ru')}>
          <Grid item xs={6}>
            <FormControl error={!!formState.errors.from} margin='normal' variant='outlined' fullWidth>
              <Controller
                name='from'
                control={control}
                render={({ field }) => (
                  <DesktopDatePicker
                    label='Начало'
                    views={['day']}
                    minDate={moment().subtract(33, 'days')}
                    maxDate={moment()}
                    inputFormat='DD.MM.YYYY HH:mm:ss'
                    value={field.value}
                    onChange={handleChangeFromDatetime}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          svg: {
                            fontSize: '20px',
                          },
                        }}
                        {...register(field.name, {
                          required: true,
                        })}
                      />
                    )}
                  />
                )}></Controller>
              <FormHelperText>Начало формирования документа</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl error={!!formState.errors.to} margin='normal' variant='outlined' fullWidth>
              <Controller
                name='to'
                control={control}
                render={({ field }) => (
                  <DesktopDatePicker
                    label='Конец'
                    views={['day']}
                    minDate={fromWatch}
                    maxDate={moment()}
                    inputFormat='DD.MM.YYYY HH:mm:ss'
                    value={field.value}
                    onChange={handleChangeToDatetime}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          svg: {
                            fontSize: '20px',
                          },
                        }}
                        {...register(field.name, {
                          required: true,
                        })}
                      />
                    )}
                  />
                )}></Controller>
              <FormHelperText>Конец формирования документа</FormHelperText>
            </FormControl>
          </Grid>
        </LocalizationProvider>
      </Grid>
    </form>
  );
});

export default UserReportForm;
